import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import {
  selectEntityConfiguration,
  selectIsItemsUpdating,
  selectIsOrganicManagementDataLoading,
  selectOrganicRanksAdditionalInfo,
  selectOrganicRanksOptions,
  selectOrganicRanksSelectedOption,
} from '../../../../../../store/slice/organicRankModal'

export const useListData = () => {
  const keywordList = useSelector(selectEntityConfiguration)
  const isFetching = useSelector(selectIsOrganicManagementDataLoading)
  const isItemsUpdating = useSelector(selectIsItemsUpdating)
  const { channelID, productID, accountID } = useSelector(selectOrganicRanksAdditionalInfo)
  const options = useSelector(selectOrganicRanksOptions)
  const selected = useSelector(selectOrganicRanksSelectedOption)

  const dynamicRowName = useMemo(
    () => (selected && options.length ? options.find((item) => item.value === selected)?.label : ''),
    [selected, options]
  )

  return {
    keywordList,
    isFetching,
    channelID,
    productID,
    accountID,
    isItemsUpdating,
    dynamicRowName,
    dynamicRowKey: selected,
  }
}
